export default __webpack_public_path__ + "static/media/gmail.90995eb1.svg";